<template>
  <div class="planets anim-plane" :class="animActive && 'go'">
    <div class="sun" ref="sun">
      <div class="planet mercury">
        <svg viewBox="0 0 100 100">
          <circle fill="#fff" cx="50" cy="50" r="50" />
        </svg>
      </div>
      <div class="planet mars">
        <svg viewBox="0 0 100 100">
          <circle fill="#fff" cx="50" cy="50" r="50" />
        </svg>
      </div>
      <div class="planet earth">
        <svg viewBox="0 0 100 100">
          <circle fill="#fff" cx="50" cy="50" r="50" />
        </svg>
        <span class="moon">
          <svg viewBox="0 0 100 100">
            <circle fill="#fff" cx="50" cy="50" r="50" />
          </svg>
        </span>
      </div>
      <div class="planet venus">
        <svg viewBox="0 0 100 100">
          <circle fill="#fff" cx="50" cy="50" r="50" />
        </svg>
      </div>
      <div class="planet saturn">
        <svg viewBox="0 0 100 100">
          <circle fill="#fff" cx="50" cy="50" r="50" />
        </svg>
      </div>
      <div class="planet jupiter">
        <svg viewBox="0 0 100 100">
          <circle fill="#fff" cx="50" cy="50" r="50" />
        </svg>
      </div>
      <div class="planet neptune">
        <svg viewBox="0 0 100 100">
          <circle fill="#fff" cx="50" cy="50" r="50" />
        </svg>
      </div>
      <div class="planet uranus">
        <svg viewBox="0 0 100 100">
          <circle fill="#fff" cx="50" cy="50" r="50" />
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import gsap from "gsap";
import animMixin from "@/assets/js/animMixin.js";
export default {
  name: "planetsAnim",
  props: {
      animProg: Boolean
  },
  mixins: [animMixin],

  mounted() {
    this.flicker();
  },

  methods: {
    flicker() {
      let sunDisk = this.$refs.sun;
      let self = this;
      gsap.to(sunDisk, this.randomNum(0.1, 1.5), {
        backgroundColor:
          "hsla(" +
          this.randomNum(250, 320, true) +
          ",100%," +
          this.randomNum(30, 80, true) +
          "%,1)",
        ease: `RoughEase.ease.config({
					template: Power1.easeOut,
					strength: 1,
					points: 10,
					taper: "none",
					randomize: true,
					clamp: true
				})`,
        onComplete: function() {
            if (self.animActive){
                self.flicker();
            }
             else return;
        }
      });
    }
  },
  computed: {
      animActive(){
          return this.animProg
      }

  },
  watch: {
      animActive(nv){
          if(nv){
              this.flicker();
          }

      }
  }
};
</script>
<style lang="scss">
.anim-plane {
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  overflow: hidden;
}

.sun {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 50%;
  top: 50%;
  width: 10px;
  height: 10px;
  margin-left: -5px;
  margin-top: -5px;
  display: block;
  background-color: purple;
  border-radius: 50%;
}

.planet {
  display: block;
  transform: rotate(0deg);
  -webkit-filter: blur(0);
  -webkit-transform: translateZ(0);
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  position: absolute;

  &.mercury {
    animation-duration: 22s;
    transform-origin: -100px -100px;
    width: 4px;
    height: 4px;
    top: 100px;
    left: 100px;
    margin-top: 6px;
    margin-left: 6px;
  }

  &.mars {
    animation-duration: 32s;
    transform-origin: 0 -80px;
    width: 4px;
    height: 4px;
    top: 80px;
    left: 0;
    margin-top: 6px;
    margin-left: 6px;
  }

  &.earth {
    animation-duration: 42s;
    transform-origin: -120px 0;
    width: 5px;
    height: 5px;
    top: 0;
    left: 120px;
    margin-top: 6px;
    margin-left: 6px;
  }

  &.venus {
    animation-duration: 52s;
    transform-origin: 0 60px;
    width: 2px;
    height: 2px;
    top: -60px;
    left: 0;
    margin-top: 6px;
    margin-left: 6px;
  }

  &.jupiter {
    animation-duration: 102s;
    transform-origin: 0 200px;
    width: 5px;
    height: 5px;
    top: -200px;
    left: 0;
    margin-top: 5px;
    margin-left: 5px;
  }

  &.neptune {
    animation-duration: 302s;
    transform-origin: 200px 0;
    width: 4px;
    height: 4px;
    top: 0;
    left: -200px;
    margin-top: 5px;
    margin-left: 5px;
  }

  &.uranus {
    animation-duration: 202s;
    transform-origin: 350px 350px;
    width: 4px;
    height: 4px;
    top: -350px;
    left: -350px;
    margin-top: 5px;
    margin-left: 5px;
  }

  &.saturn {
    animation-duration: 502s;
    transform-origin: 380px 380px;
    width: 5px;
    height: 5px;
    top: -380px;
    left: -380px;
    margin-top: 5px;
    margin-left: 5px;
  }
}

.moon,
.planet {
  svg {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
  }
}

.moon,
.planet {
  svg circle {
    width: 100%;
    height: 100%;
    stroke: none;
    fill: rgba(255, 255, 255, 1);
  }
}

.moon {
  position: absolute;
  transform-origin: -6px -6px;
  width: 2px;
  height: 2px;
  left: 6px;
  top: 6px;
  margin-top: 1px;
  margin-left: 1px;
  display: block;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-duration: 5s;
}

.go {
.moon,
.planet {
  animation-name: spin;
}
}



@keyframes spin {
  from {
    transform: rotate(0deg);
    -webkit-filter: blur(0);
    border-radius: 50%;
  }

  to {
    transform: rotate(360deg);
    -webkit-filter: blur(0);
    border-radius: 50%;
  }
}
</style>
